// @ts-ignore
import house from './house.svg';
// @ts-ignore
import colorfulGreenBackgroundImage from './colorful-green-background.jpeg';
// @ts-ignore
import avatarPlaceholder from './avatar-placeholder.png';

export { house, colorfulGreenBackgroundImage, avatarPlaceholder };
